var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deals-section-wrapper" },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("h4", [_vm._v(_vm._s(_vm.$t("message.deals")))]),
      ]),
      _vm._v(" "),
      _vm.deals.length
        ? _c(
            "div",
            { staticClass: "deals-section" },
            _vm._l(_vm.deals, function (deal) {
              return _c(
                "div",
                {
                  key: deal.id,
                  staticClass: "deal-row",
                  class: { "selected-row": _vm.isSelected(deal.id) },
                  on: {
                    click: function () {
                      return _vm.handleDealClick(deal)
                    },
                  },
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("div", { staticClass: "deal-info" }, [
                    _c("div", { staticClass: "deal-name" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("sell"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(deal.Deal_Name))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "deal-stage" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("linear_scale"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(deal.Stage))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "deal-footer" }, [
                      _c("div", { staticClass: "deal-owner" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("person"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$_.get(deal, "Owner.name", ""))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "deal-date" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("event"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatDate(deal.Created_Time))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "deal-selection",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleDealSelection(deal)
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "selection-circle",
                        class: { selected: _vm.isSelected(deal.id) },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("SupsisButton", {
                    staticClass: "view-deal-btn",
                    attrs: { icon: "open_in_new" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.gotoDealOnZoho(deal.id)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "loading-container" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("message.loadingDeals")))]),
              _vm._v(" "),
              _c("BucketSpinner", { staticClass: "large-spinner" }),
            ],
            1
          )
        : _c("div", { staticClass: "empty-deals-container" }, [
            _c("span", { staticClass: "material-icons empty-icon" }, [
              _vm._v(" assignment "),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "empty-text" }, [
              _vm._v(_vm._s(_vm.$t("message.noDealsFound"))),
            ]),
          ]),
      _vm._v(" "),
      _vm.selectedDeal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Deal Details",
                showFooter: false,
                className: "deal-viewer-modal",
              },
              on: { cancel: _vm.handleModalClose },
            },
            [
              _c("DealViewer", {
                attrs: { deal: _vm.selectedDeal },
                on: {
                  "connect-zoho": function ($event) {
                    return _vm.$emit("connect-zoho")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "deal-icon" }, [
      _c("i", { staticClass: "fas fa-handshake" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }